// Banderas en SVG y no emoji: Windows muestra los emoji de bandera como "AR" / "US".
export function FlagArgentina({ className }) {
  return (
    <svg viewBox="0 0 30 20" className={className} aria-hidden="true">
      <rect width="30" height="20" fill="#74ACDF" />
      <rect y="6.67" width="30" height="6.67" fill="#FFFFFF" />
      <circle cx="15" cy="10" r="2.1" fill="#F6B40E" />
    </svg>
  );
}

export function FlagUSA({ className }) {
  const stripe = 20 / 13;
  return (
    <svg viewBox="0 0 30 20" className={className} aria-hidden="true">
      <rect width="30" height="20" fill="#FFFFFF" />
      {Array.from({ length: 7 }, (_, i) => (
        <rect key={i} y={i * 2 * stripe} width="30" height={stripe} fill="#B22234" />
      ))}
      <rect width="12" height={stripe * 7} fill="#3C3B6E" />
      {Array.from({ length: 12 }, (_, i) => (
        <circle key={i} cx={1.8 + (i % 4) * 2.8} cy={1.9 + Math.floor(i / 4) * 3.3} r="0.55" fill="#FFFFFF" />
      ))}
    </svg>
  );
}
